import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/cooking/cooking-dynamic-topic/page',
    method: 'get',
    params
  })
}

export function addObj(data) {
  return request({
    url: '/cooking/cooking-dynamic-topic/add',
    method: 'post',
    data
  })
}
export function putObj(data) {
  return request({
    url: '/cooking/cooking-dynamic-topic/edit',
    method: 'post',
    data
  })
}
export function delObj(data) {
  return request({
    url: '/cooking/cooking-dynamic-topic/delete',
    method: 'post',
    data
  })
}
export function getObj(id) {
  return request({
    url: '/cooking/cooking-dynamic-topic/detail',
    method: 'get',
    params: { id }
  })
}
export function putTop(params) {
  return request({
    url: '/cooking/cooking-dynamic-topic/zd',
    method: 'get',
    params
  })
}
